import React, { useState, useContext } from "react";
import { Box, CardType, Cluster } from "@thecb/components";
import { ThemeContext } from "styled-components";
import parse from "html-react-parser";
import dompurify from "dompurify";
import RadioSection from "/components/radio-section";
import PaymentFormCard from "/components/payment-form-card";
import PaymentFormACH from "/components/payment-form-ach";
import {
  ACH_METHOD,
  CC_METHOD
} from "../../../../../../constants/data_constants";

const InlinePaymentCaptureSection = ({
  allowedPaymentInstruments,
  addCreditCardForm,
  addCreditCardFormActions,
  addAchForm,
  addAchFormActions,
  showErrors = false,
  selectedPaymentType: externalSelectedType,
  onPaymentTypeChange
}) => {
  const { metadata } = useContext(ThemeContext);
  const terms = metadata?.data?.termsAndConditions;
  const termsContent = terms?.content
    ? parse(dompurify.sanitize(terms.content))
    : null;
  const termsTitle = terms?.title;

  const canUseCC = allowedPaymentInstruments?.includes(CC_METHOD);
  const canUseACH = allowedPaymentInstruments?.includes(ACH_METHOD);

  const [internalSelectedType, setInternalSelectedType] = useState("");
  const selectedPaymentType = externalSelectedType ?? internalSelectedType;

  const handleTypeChange = type => {
    setInternalSelectedType(type);
    onPaymentTypeChange?.(type);
  };

  const cardIconsContent = (
    <Cluster
      childGap="0.25rem"
      aria-label="Accepted card types: Visa, Mastercard, Discover, American Express"
    >
      {["VISA", "MASTERCARD", "DISCOVER", "AMEX"].map(type => (
        <CardType key={type} type={type} size="small" />
      ))}
    </Cluster>
  );

  const sections = [
    canUseACH && {
      title: "Checking Account",
      id: ACH_METHOD,
      content: (
        <PaymentFormACH
          {...addAchForm}
          {...addAchFormActions}
          showErrors={showErrors}
          variant="collapsible"
          termsContent={termsContent}
          termsTitle={termsTitle}
        />
      )
    },
    canUseCC && {
      title: "Credit Card",
      id: CC_METHOD,
      rightTitleContent: cardIconsContent,
      content: (
        <PaymentFormCard
          {...addCreditCardForm}
          {...addCreditCardFormActions}
          showErrors={showErrors}
          variant="collapsible"
          termsContent={termsContent}
          termsTitle={termsTitle}
        />
      )
    }
  ].filter(Boolean);

  return (
    <Box padding="0">
      <RadioSection
        sections={sections}
        openSection={selectedPaymentType}
        toggleOpenSection={handleTypeChange}
      />
    </Box>
  );
};

export default InlinePaymentCaptureSection;
